export default "__VITE_ASSET__D5ZysDJD__"